import WirelineDepartmentsTabs from './WirelineDepartmentsTabs';

export default WirelineDepartmentsTabs;
